<!--
 * @Description: 真人算命 - PC端
 * @Author: xiuwen
 * @Date: 2024-12-25 11:26:47
 * @LastEditors: zishu
 * @LastEditTime: 2026-03-03 09:52:45
-->
<template>
	<main class="pc-index" :lang="pageLang">
		<!-- <div class="pc-header" @click="toStart"></div>
		<div class="download-app">
			先知命局App適用所有 iOS 和 Android 設備，安全下載隨時與命理通靈師溝通暢聊
			<div class="download-btn">
				<div class="download-btn-ios" @click="downloadApp('ios')"></div>
				<div class="download-btn-android" @click="downloadApp('android')"></div>
			</div>
		</div> -->

		<div class="main pc-center-1200">
			<TeacherResourceSection />
			<TeacherRecommendSection />

			<section ref="trustSectionRef" class="sub-banner">
				<div class="sub-banner-left">
					<div class="sub-banner-header">
						<div class="sub-banner-title">{{ t(`${I18N_NS}.index.subBanner.title`) }}</div>
						<div class="sub-banner-sub-title">{{ t(`${I18N_NS}.index.subBanner.subtitle`) }}</div>
					</div>
					<div class="sub-banner-review">
						<div class="sub-banner-review-top">
							<div class="name">
								{{ evaluateData[0]?.user_name || t(`${I18N_NS}.index.subBanner.defaultUserName`) }}
							</div>
							<div
								class="star-rating"
								role="img"
								:aria-label="
									t(`${I18N_NS}.index.subBanner.starRatingAria`, { score: displayScore })
								"
							>
								<img
									v-for="v in displayStarCount"
									:src="ratingStar"
									:alt="t(`${I18N_NS}.index.subBanner.starAlt`)"
									:key="`star-${v}`"
								/>
								<img
									v-for="v in 5 - displayStarCount"
									:src="emptyStar"
									:alt="t(`${I18N_NS}.index.subBanner.emptyStarAlt`)"
									:key="`empty-star-${v}`"
								/>
								<span class="score">{{ displayScore }}</span>
							</div>
						</div>
						<div class="content">
							{{ evaluateData[0]?.content }}
						</div>
					</div>
				</div>
				<div class="sub-banner-right">
					<div
						class="tag-item"
						v-for="(item, index) in tagList"
						:key="item.title"
						:class="`tag-bg-${index + 1}`"
					>
						<img class="tag-item-icon" :src="item.icon" :alt="item.desc" />
						<div class="tag-item-info">
							<div class="tag-item-title">{{ item.title }}</div>
							<div class="tag-item-desc">{{ item.desc }}</div>
						</div>
					</div>
				</div>
			</section>

			<!-- <ClassroomSection /> -->

			<!-- <TeacherList
				title="篩選專屬真人通靈命理師"
				subTitle="依據個人命理特徵，結合您的境遇，契合您的困惑，匹配適配的命理通靈師。"
			/> -->

			<!-- <TeacherList
				:sortType="2"
				type="1"
				title="人氣最高的通靈師"
				subTitle="被公認為最具指導性的通靈師"
			/> -->

			<!-- <TeacherList
				:themeType="1"
				:jumpType="1"
				type="2"
				title="情感關係最佳通靈師"
				subTitle="在愛情和兩性關係上最優秀的通靈師"
			/> -->

			<!-- <TeacherList
				:sortType="1"
				type="3"
				:jumpType="2"
				title="評分最高的通靈師"
				subTitle="每一次服務都得到滿意的評分"
			/> -->

			<!-- 名师咨询 -->
			<!-- <section aria-label="名師諮詢">
				<TeacherConsult />
			</section> -->

			<!-- <section aria-label="用戶評價">
				<Evaluate :evaluateData="evaluateData" />
			</section> -->

			<!-- <KolRecommend /> -->
			<!-- <HelpSection /> -->

			<!-- <CategorySection /> -->

			<!-- rank -->
			<!-- <section class="rank" aria-label="排行榜區域">
				<QuestionRank />
				<HotTalk />
			</section> -->
			<!-- <AboutSection /> -->

			<!-- <NewsSection /> -->

			<!-- <JoinUs /> -->

			<!-- <ExplainSection /> -->

			<!-- <div
        class="free-banner"
        v-if="!isLogin"
        @click="openLogin"
        role="button"
        tabindex="0"
        aria-label="免費諮詢橫幅"
      ></div> -->
			<!-- 评价 -->

			<!--  -->
			<!-- <div class="choose-banner" role="img" aria-label="選擇服務橫幅"></div> -->
			<!-- 咨询分类 -->
			<!-- <section aria-label="諮詢分類">
        <ClientOnly>
          <ConsultType :data="teacherTypeData" />
        </ClientOnly>
      </section> -->

			<!-- 老师排行榜 -->
			<!-- <section class="teacher-rank" aria-label="老師排行榜">
        <h2 class="title">老師排行榜</h2>
        <div class="rank">
          <TeacherRank :data="rankingData?.dongfang || []" :type="'dongfang'" />
          <TeacherRank :data="rankingData?.tarot || []" :type="'tarot'" />
        </div>
      </section> -->
			<!-- 老师分类 -->
			<!-- <section aria-label="老師分類">
        <ClientOnly>
          <TeacherType />
        </ClientOnly>
      </section> -->
			<!-- 描述 -->
			<!-- <section class="question" ref="questionsRef" aria-label="常見問題">
        <Describe />
      </section> -->
		</div>
	</main>
</template>

<script setup>
import { ref, computed } from "vue";
import { downloadApp } from "~/utils/common";
import { getChannel } from "~/utils/getChannel";
import { useMasterFortunePageData } from "@variants/seer/master-fortune/composables/useMasterFortunePageData";

// 组件
import ConsultType from "./components/consult-type/index.vue";
import QuestionRank from "./components/question-rank/index.vue";
import HotTalk from "./components/hot-talk/index.vue";
import Evaluate from "./components/evaluate/index.vue";
import TeacherConsult from "./components/teacher-consult/index.vue";
import TeacherRank from "./components/teacher-rank/index.vue";
import TeacherType from "./components/teacher-type/index.vue";
import Describe from "./components/describe/index.vue";
// import ClassroomSection from "./components/classroom-section/index.vue";
import TeacherList from "./components/teacher-list/index.vue";
import CategorySection from "./components/category-section/index.vue";
import AboutSection from "./components/about-section/index.vue";
import JoinUs from "./components/join-us/index.vue";
import HelpSection from "./components/help-section/index.vue";
import KolRecommend from "./components/kol-recommend/index.vue";
import ExplainSection from "./components/explain-section/index.vue";
import NewsSection from "./components/news-section/index.vue";
import TeacherRecommendSection from "./components/teacher-recommend-section/index.vue";
import TeacherResourceSection from "./components/teacher-resource-section/index.vue";
import { useRoute } from "vue-router";
import statUserIcon from "./images/stat-user.png";
import statChartIcon from "./images/stat-chart.png";
import statStarIcon from "./images/stat-star.png";
import statGlobeIcon from "./images/stat-globe.png";
import ratingStar from "../images/rating-star.png";
import emptyStar from "./images/no_star.png";

useMentorJoinFont();
import { nextTick, onMounted } from "vue";
import { logEvent } from "~/utils/firebase";
import usePixel from "~/hooks/usePixel";
const { reportGooglePixelEvent } = usePixel();
import { customTrackEvent } from "~/utils/customTrackEvent";
import { useI18n } from "~/composables/useI18n";
import { useMentorListTracking } from "../composables/useMentorListTracking";
import { useIntersectionObserver } from "@vueuse/core";

const I18N_NS = "masterFortune";

const { t, locale, trackTranslationDeps } = useI18n();
const { track, mentorType } = useMentorListTracking({
	deviceType: "pc",
	mentorType: "normal",
});
const pageLang = computed(() => (locale?.value === "en" ? "en" : "zh-TW"));
const trustSectionRef = ref(null);
const trustViewed = ref(false);

useHead(() => {
	trackTranslationDeps();
	return {
		title: t(`${I18N_NS}.meta.title`),
		meta: [
			{ name: "keywords", content: t(`${I18N_NS}.meta.keywords`) },
			{ name: "description", content: t(`${I18N_NS}.meta.description`) },
		],
	};
});

const { data: pageData } = useMasterFortunePageData("pc");

const evaluateData = computed(() => pageData.value?.evaluateList || []);
const rankingData = computed(() => pageData.value?.rankingData || { dongfang: [], tarot: [] });

const displayScore = computed(() => {
	const score = Number(evaluateData.value?.[0]?.score);

	if (!score) {
		return "5.0";
	}

	return Math.min(score, 5).toFixed(1);
});

const displayStarCount = computed(() => {
	const score = Number(evaluateData.value?.[0]?.score);

	if (!score) {
		return 5;
	}

	return Math.min(Math.ceil(score), 5);
});

const tagList = computed(() => {
	trackTranslationDeps();
	return [
		{
			title: t(`${I18N_NS}.index.tags.0.title`),
			desc: t(`${I18N_NS}.index.tags.0.desc`),
			icon: statUserIcon,
		},
		{
			title: t(`${I18N_NS}.index.tags.1.title`),
			desc: t(`${I18N_NS}.index.tags.1.desc`),
			icon: statChartIcon,
		},
		{
			title: t(`${I18N_NS}.index.tags.2.title`),
			desc: t(`${I18N_NS}.index.tags.2.desc`),
			icon: statStarIcon,
		},
		{
			title: t(`${I18N_NS}.index.tags.3.title`),
			desc: t(`${I18N_NS}.index.tags.3.desc`),
			icon: statGlobeIcon,
		},
	];
});

const route = useRoute();
const { to } = route.query;
const questionsRef = ref(null);
const elMap = ref({
	questions: questionsRef,
});

onMounted(() => {
	if (import.meta.client) {
		track("mentor_list_page_view", {
			mentor_type: mentorType,
		});
		logEvent("site_realfort_uv");
		reportGooglePixelEvent("gw_consult_page_view");
		customTrackEvent("gw_master_fortune_page_view");
	}

	nextTick(() => {
		if (to) {
			const el = elMap.value[to];

			setTimeout(() => {
				scrollToEl(el);
			}, 1600);
		}
	});
});

useIntersectionObserver(
	trustSectionRef,
	([entry]) => {
		if (!entry?.isIntersecting || trustViewed.value) return;
		trustViewed.value = true;
		track("mentor_trust_section_view", {
			section_id: "mentor_trust",
			stat_count: tagList.value.length,
		});
	},
	{ threshold: 0.5 }
);

const scrollToEl = el => {
	if (el) {
		el.scrollIntoView({ behavior: "smooth" });
	}
};

const toStart = () => {
	logEvent("gw_to_consult_click", {
		channel: getChannel(),
	});

	navigateTo("/seer/consult");
};
</script>

<style lang="scss" scoped>
.pc-index {
	background: #fff;
	padding-bottom: 80px;
	overflow-x: clip;
	font-family: "Source Han Serif CN", serif;
	.pc-header {
		width: 100%;
		min-width: 1168px;
		height: 577px;
		background:
			url("./images/seer_banner.png") no-repeat center center/ 1920px 577px,
			linear-gradient(to bottom, #fff3e5, #fffcf9, #ffffff);
		cursor: pointer;
	}

	.download-app {
		width: 100%;
		min-width: 1168px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 64px;
		background: #fff;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
		line-height: 64px;

		.download-btn {
			display: flex;
			align-items: center;

			div {
				width: 40px;
				height: 40px;
				margin-left: 8px;
			}

			.download-btn-ios {
				background: url("./images/download_ios.png") no-repeat center center/ 100% 100%;
			}

			.download-btn-android {
				background: url("./images/download_android.png") no-repeat center center/ 100% 100%;
			}
		}
	}

	.main {
		margin-top: 40px;
		display: flex;
		flex-direction: column;
		gap: 40px;
		min-width: 0;
		font-family: "Source Han Serif CN", serif;

		.sub-banner {
			width: 100%;
			min-width: 0;
			display: flex;
			gap: 24px;
			background: #fff;
			padding: 20px;
			border-radius: 10px;
			border: 1px solid #efefef;
			box-sizing: border-box;

			.sub-banner-right {
				flex-shrink: 0;
				width: calc(266px * 2 + 24px);
				max-width: 100%;
				display: flex;
				flex-wrap: wrap;
				gap: 24px;

				.tag-item {
					width: 266px;
					max-width: 100%;
					height: 139px;
					border-radius: 8px;
					display: flex;
					gap: 24px 29px;
					padding: 24px;
					box-sizing: border-box;

					&.tag-bg-1 {
						background: linear-gradient(0deg, #ffffff 0%, #ffeaea 100%), #ffeaea;
					}

					&.tag-bg-2 {
						background: linear-gradient(0deg, #ffffff 0%, #eaf1ff 100%), #eaf1ff;
					}

					&.tag-bg-3 {
						background: linear-gradient(0deg, #ffffff 0%, #fffaea 100%), #fffaea;

						.tag-item-title {
							letter-spacing: 0px;
						}
					}

					&.tag-bg-4 {
						background: linear-gradient(0deg, #ffffff 0%, #ebf9ee 100%), #ebf9ee;
					}

					.tag-item-icon {
						width: 28px;
						height: 28px;
						flex-shrink: 0;
						object-fit: contain;
					}

					.tag-item-info {
						display: flex;
						flex-direction: column;
						gap: 12px;
					}

					.tag-item-title {
						font-weight: 600;
						font-size: 24px;
						color: #333333;
						letter-spacing: 3px;
						line-height: 27px;
					}

					.tag-item-desc {
						font-weight: 400;
						font-size: 18px;
						color: #333333;
						line-height: 20px;
					}
				}
			}

			.sub-banner-left {
				flex: 1;
				min-width: 0;
				display: flex;
				flex-direction: column;

				.sub-banner-header {
					border-radius: 8px;
					background: linear-gradient(0deg, #ffffff 0%, #fffbf3 100%), #ffffff;
					padding: 16px 20px;
					text-align: center;
					box-sizing: border-box;
				}

				.sub-banner-title {
					font-weight: 600;
					font-size: 28px;
					color: #333333;
					line-height: 40px;
				}

				.sub-banner-sub-title {
					font-weight: 400;
					font-size: 18px;
					color: #f2af19;
					line-height: 26px;
					margin: 8px 0;
				}

				.sub-banner-review {
					flex: 1;
					padding: 20px 10px 0;
					box-sizing: border-box;
					overflow: hidden;

					.content {
						font-weight: 400;
						font-size: 18px;
						color: #333333;
						line-height: 26px;
						display: -webkit-box;
						-webkit-line-clamp: 4;
						line-clamp: 4;
						-webkit-box-orient: vertical;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.sub-banner-review-top {
						display: flex;
						align-items: center;
						justify-content: space-between;
						padding-bottom: 12px;

						.name {
							font-weight: bold;
							font-size: 24px;
							color: #333333;
							letter-spacing: 3px;
							line-height: 27px;
						}

						.star-rating {
							display: flex;
							align-items: center;
							gap: 8px;
							flex-shrink: 0;

							img {
								width: 16px;
								height: 16px;
							}

							.score {
								margin-left: 6px;
								font-weight: 400;
								font-size: 18px;
								color: #595959;
								line-height: 1;
							}
						}
					}
				}
			}
		}

		.rank {
			display: flex;
			gap: 32px;
		}

		.free-banner {
			width: 1168px;
			height: 80px;
			background: url("./images/free_banner.png") no-repeat center center/ 100% 100%;
			cursor: pointer;
		}

		.choose-banner {
			width: 1168px;
			height: 180px;
			background: url("./images/choose_banner.png") no-repeat center center/ 100% 100%;
			cursor: pointer;
		}

		.teacher-rank {
			.title {
				height: 28px;
				font-weight: 400;
				font-size: 28px;
				color: #333333;
				line-height: 28px;
			}

			.rank {
				margin-top: 20px;
				display: flex;
				justify-content: space-between;
			}
		}

		:deep(*) {
			font-family: inherit;
		}
	}
}

@media (max-width: 1200px) {
	.pc-index {
		.main {
			.sub-banner {
				flex-direction: column;

				.sub-banner-right {
					width: 100%;

					.tag-item {
						flex: 1 1 calc(50% - 12px);
						width: calc(50% - 12px);
					}
				}
			}
		}
	}
}

@media (max-width: 1024px) {
	.pc-index {
		padding-bottom: 60px;

		.main {
			margin-top: 24px;
			gap: 32px;
		}
	}
}

@media (max-width: 900px) {
	.pc-index {
		padding: 12px 0 40px;

		.main {
			margin-top: 16px;
			gap: 24px;
			padding-left: 12px;
			padding-right: 12px;

			.sub-banner {
				padding: 16px;
				gap: 16px;

				.sub-banner-left {
					.sub-banner-title {
						font-size: 22px;
						line-height: 32px;
					}

					.sub-banner-sub-title {
						font-size: 16px;
						line-height: 24px;
					}

					.sub-banner-review {
						padding-top: 16px;

						.content {
							font-size: 16px;
							line-height: 24px;
						}

						.sub-banner-review-top {
							.name {
								font-size: 18px;
								line-height: 24px;
							}

							.star-rating .score {
								font-size: 16px;
							}
						}
					}
				}

				.sub-banner-right {
					gap: 12px;

					.tag-item {
						height: auto;
						min-height: 110px;
						padding: 16px;
						gap: 16px;

						.tag-item-title {
							font-size: 20px;
							line-height: 24px;
						}

						.tag-item-desc {
							font-size: 16px;
							line-height: 22px;
						}
					}
				}
			}
		}
	}
}

@media (max-width: 720px) {
	.pc-index {
		.main {
			.sub-banner {
				.sub-banner-right {
					.tag-item {
						flex: 1 1 100%;
						width: 100%;
					}
				}
			}
		}
	}
}
</style>
